import NavbarComp from "../components/NavbarComps";
import FooterComps from "../components/FooterComps";

// Content
import ContactComps from "../components/ContactComps";

function Contact() {
    return (
        <>
        <NavbarComp />
        <ContactComps />
        <FooterComps />
    </>
    )
}

export default Contact;